@if (transitionWithDialog.media?.length) {
  <div class="provided-media">
    <div class="subtitle">
      {{ "WORKFLOW_DIALOGS.PROVIDED_MEDIA.SECTION_TITLE" | translate }}
    </div>
    <div class="files-list">
      @for (item of transitionWithDialog.media ?? []; track item.uuid) {
        <a
          class="file-item flex vcenter"
          target="_blank"
          rel="noopener noreferrer"
          [href]="item.storage_url"
        >
          <div class="file-status">
            <payee-icon name="upload-paper"></payee-icon>
          </div>
          <span class="file-name">{{ item.file_name }}</span>
        </a>
      }
    </div>
  </div>
}
